import script from "./MigrationStatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrationStatusTag.vue?vue&type=script&setup=true&lang=js"

import "./MigrationStatusTag.vue?vue&type=style&index=0&id=1e608fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e608fcc"]])

export default __exports__